import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'

function updateUser(store) {
  Auth.currentAuthenticatedUser()
    .then(user => {
      store.commit('auth/SET_USER', user)
    })
    .catch(() => {
      store.commit('auth/SET_USER', null)
    })
}

export default function observeAuth(store, router) {
  AmplifyEventBus.$on('authState', info => {
    if (info === 'signedIn') {
      router.push({ name: 'home' })
      updateUser(store)
      store.dispatch('vacancies/fetchVacancies')
    }
    if (info === 'signedOut') {
      router.push({ name: 'home' })
      updateUser(store)
      store.dispatch('vacancies/fetchVacancies')
    }
  })

  updateUser(store)
}
